export default {
  // 幣種選擇
  selectCurrency: "請選擇幣種",

  // 加載
  loading: "拼命加載中",

  // 地址轉賬情況
  addressTransferStatus: "地址轉賬情況",
  dataStatisticsCurrency: "數據統計幣種：",
  transactionAmount: "交易數量",
  transactionCount: "交易次數",
  inflow: "轉入",
  outflow: "轉出",
  amount: "金額",
  times: "次數",

  // 空狀態
  noData: "暫無數據",

  // 資金動向
  fundMovement: "資金動向情況",
  majorInflow: "主要流入",
  majorOutflow: "主要流出",
  frequentCounterparty: "頻繁交易對手",

  // 提幣作息規律
  withdrawalPattern: "提幣作息規律",
};
